import { all } from 'redux-saga/effects'
import settingSaga from './settingSaga'
import commonLogSaga from './commonLogSaga'
import userSaga from './userSaga'
import warehouseSaga from './warehouseSaga'
import supplierSaga from './supplierSaga'
import rateSaga from './rateSaga'
import transportationSaga from './transportationSaga'
import productSaga from './productSaga'
import purchasesRequestSaga from './purchasesRequestSaga'
import requestShareSaga from './requestShareSaga'
import orderSaga from './orderSaga'
import notificationSaga from './notificationSaga'
import categorieSaga from './categorieSaga'
import containerSaga from './containerSaga'
import requestPaymentSaga from './requestPaymentSaga'
import paymentOrderSaga from './paymentOrderSaga'
import transProviderSaga from './transProviderSaga'
import taxProviderSaga from './taxProviderSaga'
import currencyProviderSaga from './currencyProviderSaga'
import productGroupSaga from './productGroupSaga'
import searchRequestSaga from './searchRequestSaga'
import productPricingSaga from './productPricingSaga'
import reportSaga from './reportSaga'
import balanceOfdebtSaga from './balanceOfdebtSaga'
import priceCategorieSaga from './priceCategorieSaga'
import auditSaga from './auditSaga'

export default function* rootSaga() {
  yield all([
    settingSaga(),
    commonLogSaga(),
    userSaga(),
    warehouseSaga(),
    supplierSaga(),
    rateSaga(),
    transportationSaga(),
    productSaga(),
    purchasesRequestSaga(),
    requestShareSaga(),
    orderSaga(),
    notificationSaga(),
    categorieSaga(),
    containerSaga(),
    requestPaymentSaga(),
    paymentOrderSaga(),
    transProviderSaga(),
    taxProviderSaga(),
    currencyProviderSaga(),
    productGroupSaga(),
    searchRequestSaga(),
    productPricingSaga(),
    reportSaga(),
    balanceOfdebtSaga(),
    priceCategorieSaga(),
    auditSaga(),
  ])
}
